import { gql } from 'apollo-angular';
import { ProductVariant } from '../../models/products/product-variant';
import { Resolvers } from '@apollo/client/core';

import { Price } from '@app/shared/models/price';
import { ProductAttributes } from '../../models/products/product-attributes';
import { ProductParameter } from 'src/app/place-order/service/queries/get-orderable-products.query';

export const PackageFragment = gql`
  fragment Package on Product {
    productId
    catalogId
    name
    description
    sku
    isActive
    attributes {
      legacyProductId
    }
    price {
      amount
      unit
    }
    msrp {
      amount
      unit
    }
    categories {
      categoryId
      name
    }
    parameters {
      name
      type
      isRequired
      prompt
      hasPerQuantityRequirement
      perQuantityChildProductId
    }
    quantityRequirements {
      increment
      max
      min
    }
    subscriptionMonths
    ...on PackageProduct {
      children {
        productVariantId
        quantity
        productId
        name @client
        sku @client
        parameters @client
        price {
          amount
          unit
        }
        msrp {
          amount
          unit
        }
        product {
          name
          sku
          parameters {
            name
            type
            isRequired
            prompt
            hasPerQuantityRequirement
            perQuantityChildProductId
          }
        }
      }
      requiredProducts {
        productId
        name
      }
    }
  }`;

export interface PackageProduct {
  attributes?: ProductAttributes;
  productId: string;
  catalogId: string;
  name: string;
  description: string;
  sku: string;
  isActive: boolean;
  price: Price;
  msrp: Price;
  categories: ProductCategory[];
  parameters: ProductParameter[];
  quantityRequirements: QuantityRequirements;
  subscriptionMonths: number;
  children: ProductVariant[];
  requiredProducts: ProductBasic[];
}

export interface QuantityRequirements {
  increment: number;
  max?: number;
  min: number;
}

export interface ProductCategory {
  categoryId: string;
  name: string;
}

export interface ProductBasic {
  productId: string;
  name?: string;
}

export const ProductVariantResolver: Resolvers = {
  ProductVariant: {
    name(productVariant: ProductVariant) {
      return productVariant.product.name;
    },
    sku(productVariant: ProductVariant) {
      return productVariant.product.sku;
    },
    parameters(productVariant: ProductVariant) {
      return productVariant.product?.parameters;
    }
  }
};
